"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDotCMS = void 0;
const DotApiAuthorization_1 = require("./lib/api/DotApiAuthorization");
const DotApiConfiguration_1 = require("./lib/api/DotApiConfiguration");
const DotApiElasticSearch_1 = require("./lib/api/DotApiElasticSearch");
const DotApiEvent_1 = require("./lib/api/DotApiEvent");
const DotApiLanguage_1 = require("./lib/api/DotApiLanguage");
const DotApiNavigation_1 = require("./lib/api/DotApiNavigation");
const DotApiPage_1 = require("./lib/api/DotApiPage");
const DotApiSite_1 = require("./lib/api/DotApiSite");
const DotApiWidget_1 = require("./lib/api/DotApiWidget");
const DotCMSHttpClient_1 = require("./lib/utils/DotCMSHttpClient");
const DotApiContent_1 = require("./lib/api/DotApiContent");
const DotApiContentType_1 = require("./lib/api/DotApiContentType");
const DotApiForm_1 = require("./lib/api/DotApiForm");
const initDotCMS = (config) => {
    const httpClient = new DotCMSHttpClient_1.DotCMSHttpClient(config);
    const apiConfig = new DotApiConfiguration_1.DotApiConfiguration(httpClient);
    const apiLanguage = new DotApiLanguage_1.DotApiLanguage(apiConfig);
    const content = new DotApiContent_1.DotApiContent(httpClient);
    const dotApiContentType = new DotApiContentType_1.DotApiContentType(httpClient);
    return {
        auth: new DotApiAuthorization_1.DotApiAuthorization(),
        config: apiConfig,
        content: content,
        contentType: new DotApiContentType_1.DotApiContentType(httpClient),
        esSearch: new DotApiElasticSearch_1.DotApiElasticSearch(httpClient),
        event: new DotApiEvent_1.DotApiEvent(),
        form: (formConfig) => new DotApiForm_1.DotApiForm(dotApiContentType, formConfig),
        language: apiLanguage,
        nav: new DotApiNavigation_1.DotApiNavigation(httpClient),
        page: new DotApiPage_1.DotApiPage(httpClient, apiLanguage),
        site: new DotApiSite_1.DotApiSite(httpClient),
        widget: new DotApiWidget_1.DotApiWidget(httpClient),
        httpClient
    };
};
exports.initDotCMS = initDotCMS;
